import s from './PageLayout.module.sass'

import React, { FC, memo } from 'react'

import { HeaderAdvert } from '@app/PageLayout/components/HeaderAdvert'
import { useAppSelector } from '@app/model/store'
import { useErrorCatcher } from '@app/PageLayout/handlers/useErrorCatcher'
import { useResizeWindow } from '@app/PageLayout/handlers/useResizeWindow'

import { Notices } from '@widgets/Common/Notices'
import { Footer } from '@widgets/Common/Footer'
import { Header } from '@widgets/Common/Header'

import { ContainerGlobal } from '@shared/ui/Layout/Containers/ContainerGlobal'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { getCurrentRouteData, routeMapping } from './../service/routing/routing'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

interface Props {
  route: string
}

const Skeleton: FC<Props> = ({ route }) => {
  const { designEnv } = useClientResponsive()
  const { pageName: currentPage, component } = getCurrentRouteData(route, routeMapping)

  useResizeWindow()

  useErrorCatcher()

  // У лендинга ресторатора своя шапка
  const isShowHeader = route !== '/[city_slug]/restaurants/restorator'

  const isShowFooter = currentPage !== 'not_found' && currentPage !== 'service_err'

  const responsiveLoaded = designEnv !== 'default'

  const SkeletonPage = component

  return (
    <ErrorBoundary>
      {/* Page Layer */}
      <div className={s['body']}>
        {/* Banner Data */}

        {/* Content Data */}
        <div className={s['body-white']}>
          <ContainerGlobal>
            {responsiveLoaded && (
              <>
                {isShowHeader && <Header />}

                <div className={s['wrapper']} data-is-loading={false}>
                  {/* @ts-ignore */}
                  {component ? <SkeletonPage /> : <div></div>}
                </div>

                {isShowFooter && <Footer />}
              </>
            )}
          </ContainerGlobal>
        </div>
      </div>
    </ErrorBoundary>
  )
}

export default memo(Skeleton)
